import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';

import { Profile } from '../../shared/models/profile.model';
import { Group } from '../../shared/models/group.model';

import { StartKioskTimer, SetKioskError } from '../kiosk.actions';
import { KioskAppointment, KioskPatient } from '../kiosk.model';
import { KioskService, IUpdateContactInfoStatusParams } from '../kiosk.service';

import { getPatients, getSubscriptionId, getError, getTimer, KioskError, KioskTimer, isFetching, getUserHin, getAppointments } from '../kiosk.reducer';

@Component({
  selector: 'kiosk-informations',
  styles: [require('./kiosk-informations.component.scss')],
  template: require('./kiosk-informations.component.html'),
  preserveWhitespaces: false,
})
export class KioskInformationsComponent implements OnInit, OnDestroy {
  public patients: KioskPatient[];
  public fetchingStatus$: Observable<boolean>;

  private subscriptionId: number;
  private userHin: string;
  private group: Group;
  private hasConfirmedArrivalAppointments: boolean;
  private appointments: KioskAppointment[];
  private destroyed: Subject<boolean> = new Subject();

  constructor(
    @Inject('$state') private $state,
    private kioskService: KioskService,
    private store: Store<AppState>,
  ) {};

  ngOnInit(): void {
    this.fetchingStatus$ = this.store.select(isFetching);

    this.store.dispatch(new StartKioskTimer());

    this.store.select(getTimer)
      .takeUntil(this.destroyed)
      .subscribe((timer: KioskTimer): void => {
        if (timer === KioskTimer.Inactive) {
          this.goBackHome();
        }
      });

    this.store.select(getError)
      .takeUntil(this.destroyed)
      .subscribe((error: KioskError): void => {
        if (error !== null) {
          this.$state.go('kiosk.error');
        }
      });

    this.store.select((state: AppState): Group => state.group)
      .combineLatest(
        this.store.select(getAppointments),
        this.store.select(getPatients),
        this.store.select(getSubscriptionId),
        this.store.select(getUserHin),
        (group: Group, appointments: KioskAppointment[], patients: KioskPatient[], subscriptionId: number, userHin: string) => ({
          group,
          appointments,
          patients,
          subscriptionId,
          userHin,
        }),
      )
      .takeUntil(this.destroyed)
      .subscribe(({ group, appointments, patients, subscriptionId, userHin }): void => {
        this.group = group;
        this.subscriptionId = subscriptionId;
        this.userHin = userHin;
        this.appointments = appointments;
        this.patients = patients;
      });
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
  }

  confirmInformations(): void {
    this.kioskService
      .updateContactInfoStatus(this.group.id, {
        ...this.contactInfoStatusParam,
        upToDate: true,
      })
      .subscribe((): void => {
        this.$state.go('kiosk.appointments');
      });
  }

  setInvalidInformationError(): void {
    this.kioskService
      .updateContactInfoStatus(this.group.id, {
        ...this.contactInfoStatusParam,
        upToDate: false,
      })
      .subscribe((): void => {
        this.store.dispatch(new SetKioskError(KioskError.InvalidInformations));
      });
  }

  private goBackHome(): void {
    this.$state.go('kiosk.home');
  }

  private get contactInfoStatusParam(): IUpdateContactInfoStatusParams {
    const appointmentIds: number[] = this.appointments.map((appointment: KioskAppointment): number => appointment.appointmentId);
    return {
      subscriptionId: this.subscriptionId,
      appointmentIds: appointmentIds,
      hin: this.userHin,
    };
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/kiosk/kiosk-informations/kiosk-informations.component.ts